export interface Brand {
  id: string;
  name: string;
  svgPath: string;
  image?: string;
}

export const brandsData: Brand[] = [
  {
    id: "perla-home",
    name: "Perla Home",
    image: "/logos/perla-home.svg",
    svgPath: "/images/brands/perla-home.png",
  },
  {
    id: "choco-and-more",
    name: "Choco & More",
    image: "/logos/choco-and-more.svg",
    svgPath: "/images/brands/perla-home.svg",
  },
  // {
  //   id: "ats",
  //   name: "ATS",
  //   image: "/logos/ats.svg",
  //   svgPath: "/images/brands/ats.jpg",
  // },
  {
    id: "at-home",
    name: "At Home (USA)",
    image: "/logos/at-home.svg",
    svgPath: "/images/brands/at-home.svg",
  },
  // {
  //   id: "maisons-du-monde",
  //   name: "Maisons du Monde",
  //   image: "/logos/maisons-du-monde.svg",
  //   svgPath: "/images/brands/maisons-du-monde.jpg",
  // },
  {
    id: "habitat-uk",
    name: "Habitat UK",
    image: "/logos/habitat-uk.svg",
    svgPath: "/images/brands/Habitat-logo-black.webp",
  },
  {
    id: "the-range",
    name: "The Range",
    image: "/logos/the-range.svg",
    svgPath: "/images/brands/the-range.webp",
  },
  {
    id: "zara-home",
    name: "Zara Home",
    image: "/logos/zara-home.svg",
    svgPath: "/images/brands/zara-home.svg",
  },
  {
    id: "creative-co-op",
    name: "Creative Co-Op",
    image: "/logos/creative-co-op.svg",
    svgPath: "/images/brands/ccoi-logo.webp",
  },
  {
    id: "bloomingville",
    name: "Bloomingville",
    image: "/logos/bloomingville.svg",
    svgPath: "/images/brands/bloomingville.png",
  },
  {
    id: "madam-stoltz",
    name: "Madam Stoltz",
    image: "/logos/madam-stoltz.svg",
    svgPath: "/images/brands/madam-stoltz.svg",
  },
  {
    id: "boltze-group",
    name: "Boltze Group",
    image: "/logos/boltze-group.svg",
    svgPath: "/images/brands/boltze-group.svg",
  },
  {
    id: "kaemingk",
    name: "Kaemingk",
    image: "/logos/kaemingk.svg",
    svgPath: "/images/brands/kaemingk.svg",
  },
  {
    id: "gilde-handwerk",
    name: "GILDE Handwerk",
    image: "/logos/gilde-handwerk.svg",
    svgPath: "/images/brands/gilde-handwerk.png",
  },
  // {
  //   id: "parlane-living",
  //   name: "Parlane Living",
  //   image: "/logos/parlane-living.svg",
  //   svgPath: "/images/brands/parlane-living.jpg",
  // },
  {
    id: "premier-housewares",
    name: "Premier Housewares",
    image: "/logos/premier-housewares.svg",
    svgPath: "/images/brands/premier-housewares.webp",
  },
  {
    id: "heinen-delfts-blauw",
    name: "Heinen Delfts Blauw",
    image: "/logos/heinen-delfts-blauw.svg",
    svgPath: "/images/brands/heinen-delfts-blauw.webp",
  },
  {
    id: "chehoma",
    name: "Chehoma",
    image: "/logos/chehoma.svg",
    svgPath: "/images/brands/chehoma-logo-full.svg",
  },
];